import { RecHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const GetProgramLevelByProgramTypeData = (orgUnitId, programTypeId, state, setState) => {
  if (state.isArrayLoading !== true && orgUnitId && programTypeId > 0 && !state.message) {
    let newState = {
      ...state,
      orgUnitId,
      programTypeId,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const programTypeIdForUrl = programTypeId ? encodeURIComponent(programTypeId) : 'NaN';

    const url = `/ProgramLevelInstance/Current?orgUnitId=${orgUnitIdForUrl}&programTypeId=${programTypeIdForUrl}`;
    RecHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  };
};

export default GetProgramLevelByProgramTypeData;